var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownTriangleBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.68077 13.8297C10.0789 14.3984 10.9211 14.3984 11.3192 13.8297L16.3986 6.57346C16.8625 5.91068 16.3884 5 15.5793 5L5.42065 5C4.61163 5 4.13748 5.91068 4.60142 6.57346L9.68077 13.8297Z",
    fill: "#1167ED"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownTriangleBlue);
export default __webpack_public_path__ + "static/media/down_triangle_blue.6c1277f5589dbbec01e7bd598facb271.svg";
export { ForwardRef as ReactComponent };